export default __webpack_public_path__ + "static/media/13.93c955bc.svg";